import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import PageHeader from "../components/PageHeader";
import CoverGrid from "../components/CoverGrid";
import { PRODUCTS } from "../data/products";

/**
 * Generic collection page (Libri, Guide, Manuali, Dossier, Consulenze,
 * Sessioni, TIME IMMERSION, TRASFOPRODUCT). Renders header + grid of items
 * using the same layout across the whole platform.
 */
export default function CatalogCollectionPage({
  collectionKey,
  eyebrow,
  title,
  description,
  testId,
}) {
  const collection = PRODUCTS[collectionKey];
  if (!collection) return null;
  const { items, basePath, parentTo, parentLabel, aspect } = collection;

  return (
    <div className="px-5 sm:px-8 lg:px-12 py-16 sm:py-20 max-w-6xl mx-auto">
      <Link
        to={parentTo}
        data-testid={`${testId}-back-link`}
        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-white/40 hover:text-white/80 transition mb-10"
      >
        <ChevronLeft className="w-3.5 h-3.5" />
        {parentLabel}
      </Link>

      <PageHeader
        eyebrow={eyebrow}
        title={title}
        description={description}
        testId={`${testId}-header`}
      />

      <CoverGrid
        items={items}
        basePath={basePath}
        aspect={aspect}
        testId={`${testId}-grid`}
      />
    </div>
  );
}
